import { isPassableTerrain } from '@wareena/grid-battles-entity/game/map/terrain';
import { findPathAStar } from '@wareena/game-algorithms';
function getPathToPosition(agentUnit, targetPosition, hexProperties, rules, allUnits, mapHexes, doesUnitBlockPosition) {
    if (hexProperties.getDistance(agentUnit.position, targetPosition) >
        agentUnit.movementPoints + 1) {
        return null;
    }
    const { cost: movementCost, path } = findPathAStar({
        startPosition: agentUnit.position,
        targetPosition: {
            column: targetPosition.column,
            row: targetPosition.row,
        },
        getExistingNeighbours: (position) => {
            const neighbours = rules.getExistingNeighbours(position);
            return neighbours.filter((n) => {
                const hex = mapHexes.find((h) => h.column === n.column && h.row === n.row);
                if (!hex || !isPassableTerrain(hex.terrainId)) {
                    return false;
                }
                const unitOnPosition = rules.getUnitOnPosition(n, allUnits);
                if (unitOnPosition) {
                    if (doesUnitBlockPosition) {
                        return !doesUnitBlockPosition(unitOnPosition, n);
                    }
                    return false;
                }
                return true;
            });
        },
        getMovementCost: (from, to) => {
            const cost = rules.getMovementCost(from, to, agentUnit);
            if (cost === null) {
                return 1_000_000;
            }
            return cost;
        },
        getHeuristicDistance: (from, to) => {
            return hexProperties.getDistance(from, to);
        },
    });
    if (movementCost <= agentUnit.movementPoints) {
        return path.slice(1).map((p) => ({ column: p.column, row: p.row }));
    }
    return null;
}
export default getPathToPosition;
